// @ts-check
export const TOPIC = /** @type {const} */ ({
  // POPUP_ANNOUNCEMENT
  POPUP_ANNOUNCEMENT_OCCURRENCE: 'POPUP_ANNOUNCEMENT_OCCURRENCE',
  POPUP_ANNOUNCEMENT_MORE_THAN_TEN_SECOND: 'POPUP_ANNOUNCEMENT_MORE_THAN_TEN_SECOND',
  POPUP_ANNOUNCEMENT_LAST_SLIDE: 'POPUP_ANNOUNCEMENT_LAST_SLIDE',
  POPUP_ANNOUNCEMENT_CALL_TO_ACTION: 'POPUP_ANNOUNCEMENT_CALL_TO_ACTION',
  POPUP_ANNOUNCEMENT_ON_CLOSE: 'POPUP_ANNOUNCEMENT_ON_CLOSE',
  POPUP_ANNOUNCEMENT_NOT_SHOW_AGAIN: 'POPUP_ANNOUNCEMENT_NOT_SHOW_AGAIN',

  // NOTIFICATION
  NOTIFICATION_CLICKED: 'NOTIFICATION_CLICKED',
  NOTIFICATION_ITEM_CLICKED: 'NOTIFICATION_ITEM_CLICKED',
  NOTIFICATION_TAB_CLICKED: 'NOTIFICATION_TAB_CLICKED',

  // CLASSROOM
  CLASSROOM_HEARTBEAT: 'CLASSROOM_HEARTBEAT',
  CLASSROOM_TOC_TOGGLE_CLICKED: 'CLASSROOM_TOC_TOGGLE_CLICKED',
  CLASSROOM_DOCUMENT_TOGGLE_CLICKED: 'CLASSROOM_DOCUMENT_TOGGLE_CLICKED',
  CLASSROOM_SECTION_CLICKED: 'CLASSROOM_SECTION_CLICK',
  CLASSROOM_SUBSECTION_CLICKED: 'CLASSROOM_SUBSECTION_CLICKED',
  CLASSROOM_DOWNLOAD_ITEM: 'CLASSROOM_DOWNLOAD_ITEM',
  CLASSROOM_USE_ROOTED_DEVICE: 'CLASSROOM_USE_ROOTED_DEVICE',
  CLASSROOM_USE_EMULATOR: 'CLASSROOM_USE_EMULATOR',
  CLASSROOM_RECORD_SCREEN: 'CLASSROOM_RECORD_SCREEN',
  CLASSROOM_MULTIPLE_SCREEN: 'CLASSROOM_MULTIPLE_SCREEN',
  CLASSROOM_SUBSECTION_VIDEO_COMPLETE: 'CLASSROOM_SUBSECTION_VIDEO_COMPLETE',
  CLASSROOM_SUBSECTION_VIDEO_COMPLETE_CLIENT: 'CLASSROOM_SUBSECTION_VIDEO_COMPLETE_CLIENT',
  CLASSROOM_SUBSECTION_CONTENT_CLICKED: 'CLASSROOM_SUBSECTION_CONTENT_CLICKED',
  CLASSROOM_SUBSECTION_VIDEO_COMPLETE_ERROR: 'CLASSROOM_SUBSECTION_VIDEO_COMPLETE_ERROR',
  CLASSROOM_SUBSECTION_VIDEO_ON_VIDEO_PLAYER_ERROR:
    'CLASSROOM_SUBSECTION_VIDEO_ON_VIDEO_PLAYER_ERROR',
  CLASSROOM_SUBSECTION_VIDEO_INTERACTION: 'CLASSROOM_SUBSECTION_VIDEO_INTERACTION',

  // QUIZ
  QUIZ_START: 'QUIZ_START',
  QUIZ_SUBMIT: 'QUIZ_SUBMIT',
  QUIZ_SUBMIT_ERROR: 'QUIZ_SUBMIT_ERROR',
  QUIZ_START_ERROR: 'QUIZ_START_ERROR',

  // MYPATH
  MYPATH_CLICKED: 'MYPATH_CLICKED',
  MYPATH_ONBOARDING_CLICKED: 'MYPATH_ONBOARDING_CLICKED',

  // FAQ
  FAQ_OPEN_PANEL: 'FAQ_OPEN_PANEL',
  FAQ_CLOSE_PANEL: 'FAQ_CLOSE_PANEL',
  FAQ_ITEM_CLICKED: 'FAQ_ITEM_CLICKED',
  FAQ_ITEM_BACK_BUTTON_CLICKED: 'FAQ_ITEM_BACK_BUTTON_CLICKED',
  FAQ_VOTE_ITEM: 'FAQ_VOTE_ITEM',
  FAQ_OPEN_CLEAR: 'FAQ_OPEN_CLEAR',
  FAQ_SUBMITTED_CLEAR_TICKET: 'FAQ_SUBMITTED_CLEAR_TICKET',
});

/**
 * @typedef {TOPIC[keyof typeof TOPIC]} TopicName
 */
